import React, { Component } from 'react';

const shapeTypes = [
    {
        name: "Circle",
        value: "circle"
    },
    {
        name: "Rounded Rectangle",
        value: "roundrect"
    },
    {
        name: "Triangle",
        value: "triangle"
    },
]

function SelectShape({value, onChange, id}) {
    return <select id={id} value={value} onChange={onChange} className="form-control">
        {shapeTypes.map((shape,index) => {
            return <option key={index} value={shape.value}>{shape.name}</option>
        })}
    </select>
}

class EditShapeMenu extends Component {
    constructor(props) {
        super(props);
        console.log("EditShapeMenu")
    }
    
    getNestedValue = (key, object) => {
        if (key.includes(".")) {
            let keys = key.split(".")
            let nestedObject = object
            for (let i = 0; i < keys.length; i++) {
                nestedObject = nestedObject[key[i]]
                if (nestedObject === null || typeof nestedObject === 'undefined') {
                    // Already null at this level, no point digging further
                    return null
                }                
            }
        }
        else if (key.length > 0) {
            return object[key]
        }
        else {
            throw "Unable to read value"
        }
    }
    setNestedValue = (key, value, object) => {
        if (key.includes(".")) {
            let keys = key.split(".")
            let nestedObject = object
            keys.forEach((key, index) => {
                if (index == keys.length - 1) {
                    nestedObject[key] = value
                }
                else {
                    nestedObject = nestedObject[key]
                    if (nestedObject === null || typeof nestedObject === 'undefined') {
                        // Create an empty object for futher nesting
                        nestedObject = {}
                    }
                }
            })
        }
        else if (key.length > 0) {
            object[key] = value
        }
        else {
            throw "Unable to set value"
        }
    }
    onChange = (e, name, value) => {
        if (typeof value === 'undefined') {
            value = e.target.value
        }
        let newState = {
            ...this.props.details,
        }
        this.setNestedValue(name, value, newState)
        this.props.onChange(newState)
    }
    onFloatChange = (e, name, value) => {
        if (typeof value === 'undefined') {
            value = e.target.value
        }
        value = this.handleFloat(name, value)
        this.onChange(e,name,value)
    }
    onCornerRadiusChange = (e, name, value) => {
        if (typeof value === 'undefined') {
            value = e.target.value
        }
        value = this.handleFloat(name, value)
        if (value * 1 < 0) {
            value = 0
        }
        else if (value * 1 > 1) {
            value = 1
        }
        this.onChange(e,name,value)
    }

    handleFloat = (name, value) => {
        if (value == "") {
            return value
        }
        if (isNaN(parseFloat(value)) || isNaN(value * 1)) {
            value = this.getNestedValue(name,this.props.details)
        }
        if (value.length > 2 && value.substr(0,1) == "0" && value.substr(0,2) != "0.") {
            value = value.substr(1)
        }
        else if (value == "." ) {
            value = "0."
        }
        else if (value.length > 1 && value.substr(0,1) == ".") {
            value = "0" + value
        }
        return value
    }
    onCheckboxChange = (e, name) => {
        console.log("onCheckboxChange")
        let newValue = !this.getNestedValue(name, this.props.details)
        this.onChange(e,name,newValue ? 1 : 0)
    }
    
    getButtons = (isLandscape) => {
        let {details} = this.props
        let buttons = [
            <div key={-1}>
                <label htmlFor="showborder"><input id="showborder" type="checkbox" checked={!!this.getNestedValue('show_border', details)} onChange={(e) => this.onCheckboxChange(e,'show_border')}/> Show Border</label>
            </div>,
            <div key={0}>
                <label htmlFor="coor-x">Coor-X</label>
                <input id="coor-x" type="number" value={this.getNestedValue('x', details)} className="form-control" onChange={(e) => this.onFloatChange(e,'x')}/>
            </div>,
            <div key={1}>
                <label htmlFor="coor-y">Coor-Y</label>
                <input id="coor-y" type="number" value={this.getNestedValue('y', details)} className="form-control" onChange={(e) => this.onFloatChange(e,'y')}/>
            </div>,
            <div key={2}>
                <label htmlFor="type">Shape</label>
                <SelectShape id="type" value={details.type} onChange={(e) => this.onChange(e, 'type')}/>
            </div>,
        ];

        let buttonsForRect = []
        if (details.type == 'roundrect') {
            buttonsForRect = [
                <div key={3}>
                    <label htmlFor="width">Width</label>
                    <input id="width" type="number" className="form-control" value={details.width} onChange={(e) => this.onFloatChange(e, 'width')}/>
                </div>,
                <div key={4}>
                    <label htmlFor="height">Height</label>
                    <input id="height" type="number" className="form-control" value={details.height} onChange={(e) => this.onFloatChange(e, 'height')}/>
                </div>,
                <div key={5}>
                    <label htmlFor="cornerradius-tl">Top Left</label>
                    <input id="cornerradius-tl" step="0.1" value={this.getNestedValue('cr_tl', details)} type="number" className="form-control" onChange={(e) => this.onCornerRadiusChange(e, 'cr_tl')}/>
                </div>,
                <div key={6}>
                    <label htmlFor="cornerradius-tl">Top Right</label>
                    <input id="cornerradius-tr" step="0.1" value={this.getNestedValue('cr_tr', details)} type="number" className="form-control" onChange={(e) => this.onCornerRadiusChange(e, 'cr_tr')}/>
                </div>,
                <div key={7}>
                    <label htmlFor="cornerradius-tl">Bottom Left</label>
                    <input id="cornerradius-bl" step="0.1" value={this.getNestedValue('cr_bl', details)} type="number" className="form-control" onChange={(e) => this.onCornerRadiusChange(e, 'cr_bl')}/>
                </div>,
                <div key={8}>
                    <label htmlFor="cornerradius-tl">Bottom Right</label>
                    <input id="cornerradius-br" step="0.1" value={this.getNestedValue('cr_br', details)} type="number" className="form-control" onChange={(e) => this.onCornerRadiusChange(e, 'cr_br')}/>
                </div>,
            ]
        }
        else {
            buttonsForRect = [
                <div key={3}>
                    <label htmlFor="width">Width</label>
                    <input id="width" type="number" className="form-control" value={details.width} onChange={(e) => this.onFloatChange(e, 'width')}/>
                </div>,
            ]
        }
        return buttons.concat(buttonsForRect)
    }
    tableName = (table) => {
        return <div>
            <h4>
                {lang.table} {table.name}
            </h4>
        </div>
    }
    render() {
        const { table } = this.props
        let components = [
            this.tableName(table),
            this.getButtons(),
            this.props.trailing,
        ].flat()
        if (this.props.buttonsOnly) { 
            return <>
                {components.map((component, index) => {
                    return <div key={index} className="mb-2">
                        {component}
                    </div>
                })}
            </>
        }
        return (
            <div style={{display:"flex", flexDirection: this.props.direction == 'vertical'}}>
                {components.map((component, index) => {
                    return <div key={index} className="mb-2">
                        {component}
                    </div>
                })}
            </div>
        );
    }
}

export default EditShapeMenu;